import './vendor/CustomEase.min.js';
import './vendor/ScrollTrigger.min.js';
import './vendor/ScrollSmoother.min.js';
import './vendor/CSSRulePlugin.min.js';
import './vendor/Flip.min.js';
import './vendor/SplitText.min.js';
import './scrollAnimations';
import './animations';



jQuery(document).ready(function ($) {
  consoleMessage: {
    console.log(
      '%cCreated by %cTWK%cwww.thewebkitchen.co.uk',
      'background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;',
      'background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;',
      'background: #FFFFFF; padding: 5px 10px;'
    )
  }

  modernizer: {
    // if (!Modernizr.objectfit) {
    //     $('.object-fit').each(function () {
    //         var $container = $(this),
    //             imgUrl = $container.find('img').prop('src');
    //         if (imgUrl) {
    //             $container
    //                 .css('backgroundImage', 'url(' + imgUrl + ')')
    //                 .addClass('not-compatible');
    //         }
    //     });
    // }
  }

  menuCrest: {
    // function changeLogo() {
    //   if ($(window).width() < 768) {
    //     if (
    //       !$('.banner').hasClass('banner--simple') &&
    //       !$('body').hasClass('page-template-tpl-contact') &&
    //       !$('body').hasClass('page-template-tpl-whats-new') &&
    //       $('.banner--post').length < 1 &&
    //       !$('body').hasClass('blog') &&
    //       !$('body').hasClass('page-template-tpl-home') &&
    //       !$('body').hasClass('page-template-tpl-virtual-tour') &&
    //       !$('body').hasClass('post-type-archive-pastoral-portal')
    //     ) {
    //       let logoImgUrl = $('.top-nav__logo img')[0].src
    //       let newLogoImgUrl = logoImgUrl.replace('crest-black', 'crest-white')

    //       $('.top-nav__logo img')[0].src = newLogoImgUrl
    //     }
    //   } else {
    //     let logoImgUrl = $('.top-nav__logo img')[0].src
    //     let newLogoImgUrl = logoImgUrl.replace('crest-white', 'crest-black')

    //     $('.top-nav__logo img')[0].src = newLogoImgUrl
    //   }

    //   // Force a logo color.
    //   if ($('.top-nav__logo').hasClass('logo-color-light')) {
    //     let logoImgUrl = $('.top-nav__logo img')[0].src
    //     let newLogoImgUrl = logoImgUrl.replace('crest-black', 'crest-white')

    //     $('.top-nav__logo img')[0].src = newLogoImgUrl
    //   }
    //   if ($('.top-nav__logo').hasClass('logo-color-dark')) {
    //     let logoImgUrl = $('.top-nav__logo img')[0].src
    //     let newLogoImgUrl = logoImgUrl.replace('crest-white', 'crest-black')

    //     $('.top-nav__logo img')[0].src = newLogoImgUrl
    //   }
    // }

    // changeLogo()

    // on windows resize
    // window.addEventListener('resize', function () {
    //   //console.log('resizing');
    //   changeLogo()
    // })
  }

  menu: {
    // Add needed classes to the menu - ex. current-page-ancestor
    let activeMenuItem = document.querySelector('.current-page-item')

    if (activeMenuItem) {
      activeMenuItem.parentNode?.parentNode?.classList.add(
        'current-page-ancestor'
      )
    }

    const hamburger = document.querySelector('.hamburger-menu-wrapper')
    const menus = document.querySelector('.top-nav .menus')
    const subMenus = document.querySelectorAll('.top-nav .menus .sub-menu')
    const mainMenuItems = document.querySelectorAll(
      '.top-nav .menus #main-menu > li.menu-item > .link-container'
    )
    const secondaryMenuItems = document.querySelectorAll(
      '.top-nav .menus #secondary-menu > li.menu-item > .link-container'
    )
    const hasChildren = document.querySelectorAll(
      '.top-nav .menus #main-menu .menu-item-has-children > .link-container > a'
    )
    const hasNoChildren = document.querySelectorAll(
      '.top-nav .menus .menu-item:not(.menu-item-has-children) > .link-container > a'
    )
    const menuContainer = document.querySelector('.top-nav-menu-container')
    const searchBox = document.querySelector(
      '.top-nav-menu-container .search-box-button'
    )
    const socialMediaIcons = document.querySelector(
      '.top-nav-menu-container .social-media'
    )
    const backLink = document.querySelectorAll(
      '.top-nav-menu-container .menu-back'
    )

    let isMobile = false
    if ($(window).width() < 768) {
      isMobile = true
    }

    // Open and close menu - Hamburger clicks.
    hamburger.addEventListener(
      'click',
      function () {
        hamburger.classList.toggle('open')

        if (hamburger.classList.contains('open')) {
          // Opening the menu
          menuContainer.classList.add('open')

          let tl = gsap.timeline()
          tl.to(menus, { x: 0 })
            .fromTo(
              mainMenuItems,
              { alpha: 0, y: 50 },
              { alpha: 1, y: 0, stagger: 0.1 }
            )
            .fromTo(
              secondaryMenuItems,
              { alpha: 0, y: 50 },
              { alpha: 1, y: 0, stagger: 0.1 },
              '<+0.4'
            )
            .fromTo(searchBox, { alpha: 0 }, { alpha: 1 })
            .fromTo(socialMediaIcons, { alpha: 0 }, { alpha: 1 })

          // Open submenu if in current subpage.
          mainMenuItems.forEach((menuItem) => {
            if (
              menuItem.parentNode.classList.contains('current-page-ancestor')
            ) {
              menuItem.querySelector('a').click()
            }
          })
        } else {
          // Closing the menu
          menuContainer.classList.remove('open')

          let tl = gsap.timeline()
          tl.to(menus, { x: isMobile ? '100vw' : '50vw' })
        }
      },
      false
    )

    // Open and close sub-menu - Menu item with children clicks.
    hasChildren.forEach((menuItem) => {
      menuItem.addEventListener(
        'click',
        function (e) {
          e.preventDefault()

          const subMenu = menuItem
            .closest('.menu-item')
            .querySelector('.sub-menu')
          const subMenuItems = subMenu.querySelectorAll('li.menu-item')

          // Opening the sub-menu
          let tl = gsap.timeline()

          if (isMobile) {
            tl.to(subMenus, { x: '100vw' }, '<')
              .to(subMenu, { x: '0vw' }, '<')
              .fromTo(
                subMenuItems,
                { alpha: 0, y: 50 },
                { alpha: 1, y: 0, stagger: 0.1 },
                '<+0.4'
              )
          } else {
            tl.to(menus, { x: '-50vw' })
              .to(subMenus, { x: '100vw' }, '<')
              .to(subMenu, { x: '50vw' }, '<')
              .fromTo(
                subMenuItems,
                { alpha: 0, y: 50 },
                { alpha: 1, y: 0, stagger: 0.1 },
                '<+0.4'
              )
          }
        },
        false
      )
    })

    // Close menu before loading a new page - Menu item clicks.
    hasNoChildren.forEach((menuItem) => {
      menuItem.addEventListener(
        'click',
        function (e) {
          // Closing the menu before load (if open in same page)
          if (!e.ctrlKey) {
            gsap.to('body', { alpha: 0, duration: 0.4 })
          }
        },
        false
      )
    })

    // Go back link on menu mobile version.
    backLink.forEach((back) => {
      back.addEventListener('click', function () {
        gsap.to(subMenus, { x: '100vw', ease: 'power2' })
      })
    })
  }

  secondaryNav: {
    if (window.innerWidth < 768) {
      $('.complementary-content__title').on('click', function () {
        const secondaryMenu = $('.complementary-content')
        const secondaryMenuWidth = $('.complementary-content').innerWidth()

        $(this).toggleClass('open')

        if ($(this).hasClass('open')) {
          gsap.to(secondaryMenu, { x: -secondaryMenuWidth, duration: 0.4 })
        } else {
          gsap.to(secondaryMenu, { x: '0%', duration: 0.4 })
        }
      })
    }
  }

  anchorlinks: {
    $(document).on('click', '.scroll-to', function (event) {
      event.preventDefault()

      $('html, body').animate(
        {
          scrollTop: $($.attr(this, 'href')).offset().top - 50,
        },
        500
      )
    })
  }

  externallinks: {
    $('a[href^="mailto:"]').each(function () {
      $(this).addClass('email-link')
    })

    $('a:not(.email-link):not([class^="magnific-"]):not([data-sub-html])').each(
      function () {
        var a = new RegExp('/' + window.location.host + '/')

        if (!a.test(this.href)) {
          $(this).click(function (event) {
            event.preventDefault()
            window.open(this.href, '_blank')
          })
        }
      }
    )
    pdfs: {
      // Open PDFs in new window
      $(function () {
        $('a[href$=".pdf"]').prop('target', '_blank')
      })
    }
  }

  slider: {
    $('.full-width-slider').each(function (index) {
      var slickElement = $(this)

      slickElement.slick({
        dots: true,
        prevArrow: $(this).parent().find('.custom-arrows .custom-arrows__prev'),
        nextArrow: $(this).parent().find('.custom-arrows .custom-arrows__next'),
        fade: true,
        autoplay: true,
        autoplaySpeed: 3500,
        speed: 1200,
      })
    })

    $('.slider-with-overflow').each(function (index) {
      var slickElement = $(this)

      slickElement.slick({
        dots: false,
        prevArrow: $(this)
          .closest('.container')
          .parent()
          .find('.custom-arrows .custom-arrows__prev'),
        nextArrow: $(this)
          .closest('.container')
          .parent()
          .find('.custom-arrows .custom-arrows__next'),
        fade: false,
        autoplay: false,
        autoplaySpeed: 3500,
        speed: 1200,
        slidesToShow: 1,
      })

      // Related content on the blog archive - navigation by clicking on a teaser
      $('.related-content .slider-with-overflow .slick-slide .teaser').on(
        'click',
        function () {
          let slideClickIndex = $(this)
            .closest('.slick-slide')
            .data('slick-index')

          if (slideClickIndex > slickElement[0].slick.currentSlide) {
            slickElement.slick('slickNext')
          } else if (slideClickIndex < slickElement[0].slick.currentSlide) {
            slickElement.slick('slickPrev')
          }
        }
      )
    })

    $('.instagram-feed-slider').each(function (index) {
      var slickElement = $(this)

      slickElement.slick({
        dots: false,
        arrows: false,
        fade: false,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 1200,
        pauseOnHover: true,
        slidesToShow: 4,
        centerMode: false,
        variableWidth: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 670,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      })
    })

    /**
     * Gallery slider with thumbnails navigation.
     */
    $('.gallery-slider').each(function (index) {
      var status = $(this).find('.gallery-slider__full-nav .pages')
      var slickElement = $(this).find('.gallery-slider__full')
      var slickElementThumb = $(this).find('.gallery-slider__thumb')
      var slickElementCaption = $(this).find('.gallery-slider__caption')

      // slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      // 	//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      // 	var i = (currentSlide ? currentSlide : 0) + 1;
      // 	status.text(i + ' of ' + slick.slideCount);
      // });

      slickElement.slick({
        dots: false,
        arrows: true,
        fade: true,
        asNavFor: $(this).find('.gallery-slider__thumb, .gallery-slider__caption'),
        appendArrows: $(this).find('.gallery-slider__full-nav'),
        prevArrow:
          '<button type="button" aria-label="Previous" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" fill="none"><circle cx="32.5965" cy="32.5965" r="32.5965" fill="black"/><path d="M36.1562 27.4002L34.8201 26.064L28.1391 32.7449L28.3017 32.9066L28.1391 33.0691L34.8201 39.7501L36.1562 38.4139L30.6505 32.9066L36.1562 27.4002Z" fill="#F7D117"/></svg></button>',
        nextArrow:
          '<button type="button" aria-label="Next" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" fill="none"><circle cx="32.5965" cy="32.5965" r="32.5965" fill="black"/><path d="M29.8438 27.4002L31.1799 26.064L37.8609 32.7449L37.6983 32.9066L37.8609 33.0691L31.1799 39.7501L29.8438 38.4139L35.3495 32.9066L29.8438 27.4002Z" fill="#F7D117"/></svg></button>',
      })

      slickElementThumb.slick({
        dots: false,
        arrows: true,
        slidesToShow: 4,
        // centerMode: true,
        focusOnSelect: true,
        asNavFor: $(this).find('.gallery-slider__full, .gallery-slider__caption'),
      })

        slickElementCaption.slick({
            slidesToShow: 1,
            dots: false,
            arrows: false,
            fade: true,
            rows: 0
        })
    })
  }

  magnific: {
    // IFRAME
    $('.magnific-video').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-video-wrapper',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,

      iframe: {
        markup:
          '<div class="mfp-iframe-scaler">' +
          '<div class="mfp-close"></div>' +
          '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
          '</div>',
        patterns: {
          youtu: {
            index: 'youtu.be',
            id: function (url) {
              // Capture everything after the hostname, excluding possible querystrings.
              var m = url.match(/^.+youtu.be\/([^?]+)/)

              if (null !== m) {
                return m[1]
              }

              return null
            },
            // Use the captured video ID in an embed URL.
            // Add/remove querystrings as desired.
            src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0',
          },
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: 'https://www.youtube.com/embed/%id%?autoplay=1',
          },
        },
      },
      /* callbacks: {
				close: function() {
					console.log($( this._lastFocusedEl ).parent().find('.video-foreground iframe'));
				}
			} */
    })

    $('.magnific-video').magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-video-wrapper',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,

      iframe: {
        markup:
          '<div class="mfp-iframe-scaler">' +
          '<div class="mfp-close"></div>' +
          '<iframe class="mfp-iframe" frameborder="0" allow="autoplay"></iframe>' +
          '</div>',
        patterns: {
          youtu: {
            index: 'youtu.be',
            id: function (url) {
              // Capture everything after the hostname, excluding possible querystrings.
              var m = url.match(/^.+youtu.be\/([^?]+)/)

              if (null !== m) {
                return m[1]
              }

              return null
            },
            // Use the captured video ID in an embed URL.
            // Add/remove querystrings as desired.
            src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0',
          },
          youtube: {
            index: 'youtube.com/',
            id: 'v=',
            src: 'https://www.youtube.com/embed/%id%?autoplay=1',
          },
        },
      },
      /* callbacks: {
				close: function() {
					console.log($( this._lastFocusedEl ).parent().find('.video-foreground iframe'));
				}
			} */
    })

    // INLINE
    $('.magnific-inline-popup').magnificPopup({
      type: 'inline',

      fixedContentPos: false,
      fixedBgPos: true,

      overflowY: 'auto',

      closeBtnInside: true,
      preloader: false,

      midClick: true,
      removalDelay: 300,
      mainClass: 'my-mfp-zoom-in',
    })

    $('.magnific-full-screen-popup').magnificPopup({
      type: 'inline',

      fixedContentPos: false,
      fixedBgPos: true,

      overflowY: 'auto',

      closeBtnInside: true,
      preloader: false,

      midClick: true,
      removalDelay: 300,
      mainClass: 'my-mfp-zoom-in full-screen-popup',
      closeMarkup:
        '<span class="mfp-close"><svg width="32" height="33" xmlns="http://www.w3.org/2000/svg"><g stroke="#000" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M1.858 30.642 30.142 2.358M1.858 2.358l28.284 28.284"/></g></svg></span>',

      callbacks: {
        open: function () {
          $('body').addClass('not-scrollable')
          $('body').addClass('add-blur')
          $('.menu-search-form-container').addClass('open')

          //const inputsCurtain = CSSRulePlugin.getRule( '.full-screen-popup .mfp-content .menu-search-form-container .inputs-container:after' ) // it needs to match exactly the CSS rule.
          //const inputs        = document.querySelector( '.full-screen-popup .inputs-container' )

          //let inputsTL = gsap.timeline();

          //inputsTL
          //.fromTo( inputs, { height: 0 }, { height: '100%' } )
          //.to( inputsCurtain, { top: '100%', duration: 1.2, ease: "power1.out" } )
        },
        close: function () {
          $('body').removeClass('not-scrollable')
          $('body').removeClass('add-blur')
          $('.menu-search-form-container').removeClass('open')

          //const inputsCurtain = CSSRulePlugin.getRule( '.full-screen-popup .mfp-content .menu-search-form-container .inputs-container:after' ) // it needs to match exactly the CSS rule.
          //gsap.to( inputsCurtain, { top: '0%', duration: 0.2, ease: "power1.out" } )
        },
      },
    })

    // Inline popup slider.
    $('.modal-popup-slider').each(function () {
      let popupSlider = $(this).magnificPopup({
        mainClass: 'slider-popup',
        type: 'inline',
        delegate: 'a.magnific-inline-slider-popup',
        preload: [0, 2],
        gallery: {
          enabled: true,
        },
        closeMarkup:
          '<button title="%title%" type="button" class="mfp-close"><svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><defs><style>.cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style></defs><title/><g id="cross"><line class="cls-1" x1="7" x2="25" y1="7" y2="25"/><line class="cls-1" x1="7" x2="25" y1="25" y2="7"/></g></svg></button>',
        closeOnContentClick: false,
        removalDelay: 400,
        callbacks: {
          open: function () {
            // Open animation
            gsap.fromTo(
              '.mfp-container',
              { xPercent: 100 },
              { xPercent: 0, ease: 'power2.out' }
            )

            // Correct height to the vertical line (it depends on the title height).
            let itemSrc = $(this)[0].currItem.src
            let verticalLine = $(itemSrc).find('.vertical-line')
            let headerHeight =
              $(itemSrc).find('.popup__content__header').innerHeight() - 30

            $(verticalLine).css('height', headerHeight)
          },
          beforeClose: function () {
            // Close animation
            gsap.fromTo(
              '.mfp-container',
              { xPercent: 0 },
              { xPercent: 100, ease: 'power2.out', duration: 1 }
            )
          },
          close: function () {},
        },
      })

      // Custom navigation.
      var magnificPopup = $.magnificPopup.instance

      $('body').on('click', '.navigation-buttons__button--prev', function (e) {
        e.preventDefault()

        magnificPopup.prev()
      })
      $('body').on('click', '.navigation-buttons__button--next', function (e) {
        e.preventDefault()

        magnificPopup.next()
      })
    })

    // GALLERY SINGLE IMAGE
    $('.magnific-gallery-single-image').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-single',
      image: {
        verticalFit: true,
        titleSrc: function titleSrc(item) {
          return item.el.attr('title')
        },
      },
      gallery: {
        enabled: false,
      },
    })

    // GALLERY IMAGE
    $('.magnific-gallery-image').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      mainClass: 'mfp-img-mobile',
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.el.attr('title')
        },
      },
      gallery: {
        enabled: true,
      },
    })
  }

  accordion: {
    if ($('.block--accordion').length) {
      $('.accordion__content--wrapper').css('display', 'none') // All items closed.

      $('.block--accordion')
        .find('.js-accordion-trigger')
        .on('click', function () {
          // Close only the items in this accordion.
          $(this)
            .parent()
            .siblings()
            .find('.js-accordion-trigger')
            .next()
            .slideUp('fast') // reset
          $(this)
            .parent()
            .siblings()
            .find('.js-accordion-trigger')
            .removeClass('open') // reset

          // Close items in all accordions on the page.
          //$('.js-accordion-trigger').not(this).next().slideUp('fast'); // reset
          //$('.js-accordion-trigger').not(this).removeClass('open');    // reset

          if ($(this).hasClass('open')) {
            $(this).next().slideUp('fast')
            $(this).removeClass('open')
          } else {
            $(this).next().slideDown('fast')
            $(this).addClass('open')

            setTimeout(() => {
                // scroll to clicked element
                window.scrollTo({
                    top: $(this).parent().offset().top,
                    behavior: 'smooth'
                });
            }, 500)
          }
        })
    }
  }

  introVideo: {
    if ($('.intro-video-wrapper').length) {
      document.querySelector('.banner .banner__title').style.marginLeft =
        '-100px'
      document.querySelector('.banner .banner__title').style.marginRight =
        '-100px'

      // Const and variables
      const wordOne = document.querySelector(
        '.banner__title svg #realise-your-potential path:nth-child(1)'
      )
      const wordOneColorBlock = document.querySelector(
        '.banner__title svg #realise-your-potential #orange-block'
      )

      const wordTwo = document.querySelector(
        '.banner__title svg #realise-your-potential path:nth-child(2)'
      )

      const wordThree = document.querySelector(
        '.banner__title svg #realise-your-potential path:nth-child(3)'
      )
      const wordColorBlockGreen = document.querySelector(
        '.banner__title svg #realise-your-potential #blue-block'
      )
      const wordColorBlockYellow = document.querySelector(
        '.banner__title svg #realise-your-potential #block-grow'
      )

      //const bannerWords        = document.querySelector( '.banner__text-group' )
      const bannerText = document.querySelector(
        '.banner__text-group .banner__text'
      )
      const bannerVideo = document.querySelector(
        '.banner__video.block.block--video'
      )

      /**
       * Video Starts
       *
       * - Body not scrollable
       * - Play the video
       */
      function introVideoStarts() {
        const video = document.querySelector('video.intro-video')

        $('body').addClass('not-scrollable')

        // Listen for the canplaythrough event
        video.addEventListener('canplaythrough', () => {
          video.play()
        })

        // Check if the video is already loaded and ready to play
        // (in case when we added the event listener the event already was fired)
        if (video.readyState === 4) {
          if (video.paused) {
            video.play()
          }
        }
      }

      /**
       * Video Ends
       *
       * - Intro video clip out
       * - New content revealed
       * - Body scrollable again
       */
      function introVideoEnds() {
        gsap.set($('#created-block'), { opacity: 0 }) // The block is created after load, so it needs to be set up here. [!important it doesn't work in a variable]

        let introVideoOut = gsap.timeline({
          defaults: {
            duration: 1.5,
            ease: CustomEase.create('customEase', '0.76, 0.00, 0.24, 1.00'),
          },
        })

        introVideoOut
          .to($('.intro-video-wrapper'), { clipPath: 'inset(0% 0% 100% 0%)' })
          .from(
            wordOne,
            { opacity: 0, x: -100, duration: 0.6, ease: 'power1' },
            '-=.7'
          )
          .from(
            wordOneColorBlock,
            { opacity: 0, x: -100, duration: 0.6, ease: 'power1' },
            '<'
          )
          .from(wordTwo, { opacity: 0, duration: 0.8, ease: 'power1' }, '-=.4')
          .from(
            wordThree,
            { opacity: 0, x: 100, duration: 0.8, ease: 'power1' },
            '-=.4'
          )
          .from(
            wordColorBlockGreen,
            { opacity: 0, x: 100, duration: 0.8, ease: 'power1' },
            '<'
          )
          .from(
            wordColorBlockYellow,
            { opacity: 0, x: 100, duration: 0.8, ease: 'power1' },
            '<'
          )
          .to($('#created-block'), { opacity: 1, duration: 0 })
          .fromTo(
            bannerText,
            { opacity: 0, y: 150 },
            { opacity: 1, y: 0, ease: 'power2.out' },
            '-=0.7'
          )
          .fromTo(
            bannerVideo,
            { opacity: 0, y: 150 },
            { opacity: 1, y: 0, ease: 'power2.out' },
            '-=1.2'
          )

        $('body').removeClass('not-scrollable')
      }

      // On load, video starts.
      introVideoStarts()

      // On video ended.
      // Interval to check a couple seconds before it ends to start the transition animation.
      let videoCheckInterval = setInterval(() => {
        let introVideo = document.querySelector('.intro-video-wrapper video')
        let introVideoDuration = introVideo.duration // Outside the interval gives NaN at first and will not work.

        if (introVideo.currentTime >= introVideoDuration - 2) {
          clearInterval(videoCheckInterval)
          introVideoEnds()
        }
      }, 200)

      // Button to add sound.
      $('.intro-video-with-sound').on('click', function () {
        $('video.intro-video').prop(
          'muted',
          !$('video.intro-video').prop('muted')
        )

        if ($('video.intro-video').prop('muted')) {
          $(this).html('Unmute')
          $(this).removeClass('button--mute')
          $(this).addClass('button--unmute')
        } else {
          $(this).html('Mute')
          $(this).removeClass('button--unmute')
          $(this).addClass('button--mute')
        }
      })
      // Button to finish video early.
      $('.intro-video-skip-button').on('click', function () {
        introVideoEnds()

        clearInterval(videoCheckInterval)

        setTimeout(() => {
          $('video.intro-video').trigger('pause')
        }, 1000)
      })
    }
  }

  $('.quick-links-trigger').on('click', function () {
    $(this).parent('.top-nav__quick-links__dropdown').toggleClass('open');
  });   
})
